import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, Home } from 'lucide-react';

export function Forbidden() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-red-100 dark:bg-red-900/30 p-3 rounded-full">
            <ShieldAlert className="h-16 w-16 text-red-600 dark:text-red-400" />
          </div>
        </div>

        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">
          Acesso Negado
        </h1>
        <p className="text-xl text-gray-700 dark:text-gray-300 mb-8">
          Você não tem permissão para acessar esta área
        </p>

        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md mb-8">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-3">
            Por que isso aconteceu?
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            Esta área é restrita a usuários com privilégios de{' '}
            <span className="font-semibold">Administrador</span>. Seu perfil
            atual não possui as permissões necessárias para acessar o painel
            administrativo.
          </p>
          <div className="text-sm text-gray-500 dark:text-gray-500 border-t border-gray-100 dark:border-gray-700 pt-4">
            Se você acredita que deveria ter acesso, entre em contato com um
            administrador do sistema.
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 rounded-lg text-gray-800 dark:text-gray-200 font-medium transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar
          </button>

          <Link
            to="/"
            className="flex items-center justify-center gap-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 dark:bg-primary-700 dark:hover:bg-primary-600 rounded-lg text-white font-medium transition-colors"
          >
            <Home className="h-4 w-4" />
            Página Inicial
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Forbidden;
